import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import ProfileTab from './ProfileTab';

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
  }),
)(ProfileTab);
